var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: { visible: _vm.visibleLook, "append-to-body": "", width: "450px" },
      on: { close: _vm.closeLook },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            width: "375px",
            "min-height": "1080px",
            "padding-bottom": "35px",
            position: "relative",
          },
          style: {
            backgroundColor:
              _vm.activityInfo.type !== 4
                ? _vm.activityInfo.backgroundColor
                : "#feeec7",
          },
        },
        [
          _c("div", { staticClass: "banner" }, [
            _c("img", {
              staticClass: "full-width",
              attrs: {
                src:
                  _vm.activityInfo.type === 4
                    ? "https://qiniu-sys.ayundi.cn/img/user/new-year.png"
                    : _vm.activityInfo.images,
              },
            }),
          ]),
          _c("div", { staticClass: "record" }, [_vm._v(" 抽奖记录")]),
          _c("div", { staticClass: "pool position-relative" }, [
            _c("img", {
              staticClass: "full-width bg",
              attrs: { src: require("@/static/prize-draw/pool.png") },
            }),
            _c(
              "div",
              {
                staticClass: "list",
                staticStyle: { padding: "27px 38px 0 38px" },
              },
              [
                _vm._l(_vm.activityInfo.prizes, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "item position-absolute overflow-hide",
                      class: "item" + index,
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "95px" },
                        attrs: {
                          src: require("@/static/prize-draw/item-bg.png"),
                        },
                      }),
                      _c("div", { staticClass: "text position-absolute" }, [
                        _c("img", {
                          staticStyle: {
                            width: "38px",
                            height: "38px",
                            "margin-top": "12px",
                          },
                          attrs: {
                            src:
                              item.type === 4
                                ? "https://qiniu-sys.ayundi.cn/img_v3_02ih_10dea323-4a95-4f7c-82b3-4a03df52057g.png"
                                : item.prizeImage,
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-12 flex flex-align-center flex-justify-center",
                            staticStyle: {
                              color: "#903000",
                              width: "60px",
                              height: "35px",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(item.prizeName))])]
                        ),
                      ]),
                      index !== _vm.current
                        ? _c("div", { staticClass: "mask position-absolute" })
                        : _vm._e(),
                    ]
                  )
                }),
                _c("div", { staticClass: "start-btn position-absolute" }, [
                  _c("img", {
                    staticStyle: { width: "95px" },
                    attrs: { src: require("@/static/prize-draw/btn-bg.png") },
                  }),
                  _c(
                    "div",
                    { staticClass: "text color-fff position-absolute" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "font-weight font-32",
                          staticStyle: { "line-height": "48px" },
                        },
                        [_vm._v("抽奖")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "font-16",
                          staticStyle: { "line-height": "24px" },
                        },
                        [
                          _vm._v(
                            "剩余" +
                              _vm._s(
                                _vm.activityInfo.remainCount > 0
                                  ? _vm.activityInfo.remainCount
                                  : 0
                              ) +
                              "次"
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "padding-x-10 rule" }, [
            _c("img", {
              staticClass: "full-width",
              attrs: { src: require("@/static/prize-draw/rule-icon.png") },
            }),
            _c(
              "div",
              {
                staticClass:
                  "rule-text font-14 color-333 padding-x-20 color-bg-fff",
              },
              [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.activityInfo.description) },
                }),
              ]
            ),
          ]),
          _vm.activityInfo.fakeWinnerListToggle === 1
            ? _c("div", { staticClass: "padding-x-10 namelist" }, [
                _c("img", {
                  staticClass: "full-width",
                  attrs: {
                    src: require("@/static/prize-draw/namelist-icon.png"),
                  },
                }),
                _c(
                  "div",
                  { staticClass: "name-list padding-x-40" },
                  [
                    _vm.activityInfo.winnerList.length
                      ? _vm._l(
                          _vm.activityInfo.winnerList,
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "borders list font-14 flex flex-justify-between flex-align-center",
                              },
                              [
                                _c("div", { staticClass: "color-333" }, [
                                  _vm._v(_vm._s(item.userPhone)),
                                ]),
                                _c(
                                  "div",
                                  { staticStyle: { color: "#d14e07" } },
                                  [_vm._v(_vm._s(item.rewardName))]
                                ),
                              ]
                            )
                          }
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-justify-center flex-align-center padding-top-30",
                            staticStyle: { "min-height": "200px" },
                          },
                          [_vm._v("\n          暂无内容\n        ")]
                        ),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }